import { Environment } from '../app/types/environment.interface';

export const environment: Environment = {
  name: 'QA',
  production: true,
  appInsights: {
    key: '914490de-bf0c-4a65-b870-9384190ad60b', // mccann-coach-nx-qa-web1 used for testing
  },
  nxApi: {
    base: 'https://qaapi.azure-api.net/nxbus',
    subscriptionHeader: {
      name: 'Ocp-Apim-Subscription-Key',
      value: '7e3bae8ef5c449db97f8cbf5427d0caf',
    },
    fragment: {
      address: 'address',
      ticketsAndFares: 'fares',
      checkout: 'checkout',
      discount: 'discount',
      customer: 'customer',
      order: 'order',
    },
    minAddressSearchChars: 1,
  },
  b2c: {
    authority: 'https://nxbusdt.b2clogin.com/nxbusdt.onmicrosoft.com',
    authorityDomain: 'https://nxbusdt.b2clogin.com',
    clientId: 'd74d2101-10e4-4676-8d44-a83d8359dda5',

    redirectUris: {
      coventry: {
        redirectUri: 'https://qa.nationalexpress.com/coventry/buy/post-login',
        postLogoutRedirectUri: 'https://qa.nationalexpress.com/coventry/buy',
      },
      ['west-midlands']: {
        redirectUri:
          'https://qa.nationalexpress.com/west-midlands/buy/post-login',
        postLogoutRedirectUri:
          'https://qa.nationalexpress.com/west-midlands/buy',
      },
    },
    signUpSignInPolicy: 'B2C_1_NX_BUS_SIGNIN_SIGNUP',
  },
  cdnBaseUrl: 'https://nx-busapplication-qa.azureedge.net',
  gtm: {
    id: 'GTM-TD77RG9',
  },
};
